"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _ManagerWithSession2 = _interopRequireDefault(require("./ManagerWithSession"));

var _Lock = _interopRequireDefault(require("./model/Lock"));

var BASE_URI = 'composition/v1/compositions';

var getURI = function getURI(id) {
  return BASE_URI + "/" + id + "/lock";
};

var LockManager = /*#__PURE__*/function (_ManagerWithSession) {
  (0, _inherits2.default)(LockManager, _ManagerWithSession);

  function LockManager() {
    (0, _classCallCheck2.default)(this, LockManager);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LockManager).apply(this, arguments));
  }

  (0, _createClass2.default)(LockManager, [{
    key: "acquireLock",
    value: function acquireLock(id) {
      var url = getURI(id);
      var query = {
        session: this.session
      };
      return _apiClient.default.post(url, {
        query: query
      }).then(_Lock.default.fromJS);
    }
  }, {
    key: "passLock",
    value: function passLock(id, userId) {
      var url = getURI(id);
      var query = {
        session: this.session,
        userId: userId
      };
      return _apiClient.default.put(url, {
        query: query
      });
    }
  }, {
    key: "clearLock",
    value: function clearLock(id) {
      var url = getURI(id);
      var query = {
        session: this.session
      };
      return _apiClient.default.delete(url, {
        query: query
      });
    }
  }]);
  return LockManager;
}(_ManagerWithSession2.default);

exports.default = LockManager;
module.exports = exports.default;